import { Typography } from '@hulu/react-style-components';
import styled from 'styled-components';

export const StyledWarningNotification = styled.div`
  width: 100%;
  border-radius: 8px;
  height: 56.5px;
  border: 1px solid ${({ theme }): string => theme.admanColors!.yellow.dark.bg0[1]};
  background: ${({ theme }): string => theme.admanColors!.gray.light.bg0[0]};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${({ theme }): string => theme.spacers!.spacer06};
  padding: ${({ theme }): string => theme.spacers!.spacer04};

  & svg {
    margin-right: ${({ theme }): string => theme.spacers!.spacer04};
  }
`;

export const StyledTitle = styled(Typography).attrs({ variant: 'body1' })`
  color: ${({ theme }): string => theme.admanColors!.yellow.dark.bg0[1]};
  font-weight: 600;
  margin-right: ${({ theme }): string => theme.spacers!.spacer02};
`;
